import(/* webpackMode: "eager" */ "/vercel/path0/apps/mode-dashboard/src/app/(main)/bridge/page.tsx");
